import React from 'react'
import OriginalSpinner from '../../../components/LoadingSpinner'

export function LoadingSpinner(props) {
  if (props.hidden) {
    return null
  }

  return <OriginalSpinner {...props} />
}

export function getLoadingSpinnerProps({
  outerClass = '',
  innerClass = '',
  style = { fontSize: '50px' },
  text = '',
  hidden = false,
} = {}) {
  return {
    outerClass: `d-flex justify-content-center m-auto ${outerClass}`,
    innerClass: `text-primary ${innerClass}`,
    style: style,
    text: text,
    hidden: hidden,
  }
}
